@defer (when advancedFilters()) {
  <form [formGroup]="advancedFiltersFormGroup()!" novalidate>
    <wcg-advanced-filters
      formArrayName="filters"
      [advancedFilters]="advancedFilters()!"
      (applyFilters)="applyFilters.emit($event)"
      (clearOutFilters)="clearFilters.emit()"
    >
      <wcg-create-grid-view-actions
        [data]="gridViewData()"
        (revertGridState)="revertGridState.emit()"
      />

      @if (additionalFiltersTemplateRef()) {
        <ng-container
          [ngTemplateOutlet]="additionalFiltersTemplateRef()!"
          ngProjectAs="additional-filters"
        />
      }
    </wcg-advanced-filters>
    <wcg-filter-indicators
      [advancedFilters]="appliedFilters()!"
      (removeFilter)="removeFilter.emit($event)"
    />
  </form>
}
